import * as types from "./logSourcesActionTypes";

export function loadLogSourcesSuccess(logSources) {
  return { type: types.LOAD_LOG_SOURCES_SUCCESS, logSources };
}

export function loadLogSourcesFailed(message) {
  return { type: types.LOAD_LOG_SOURCES_FAILED, message };
}

export function loadLogSources() {
  return { type: types.LOAD_LOG_SOURCES };
}

export function selectFilter(value) {
  return { type: types.SELECT_FILTER, value };
}

export function sortLogSources(sort) {
  return { type: types.SORT_LOG_SOURCES, sort };
}



// WEBPACK FOOTER //
// ./src/log-sources/logSourceActions.js